import { WifiOff } from 'lucide-react';

import type { LLMStatus, NetworkStatus } from '@lilith-arcana-os/domain';

interface OfflineBannerProps {
  networkStatus: NetworkStatus;
  llmStatus: LLMStatus;
}

export function OfflineBanner({ llmStatus, networkStatus }: OfflineBannerProps) {
  if (networkStatus === 'online' && llmStatus !== 'fallback') {
    return null;
  }

  return (
    <div className="mb-4 flex items-center gap-3 rounded-2xl border border-[rgba(201,169,110,0.2)] bg-[rgba(128,0,64,0.22)] px-4 py-3 text-sm text-[var(--la-text)]">
      <WifiOff className="h-4 w-4 text-[var(--la-gold)]" />
      <span>
        {networkStatus !== 'online'
          ? 'Modalita offline attiva. La lettura resta disponibile con cache locale e fallback simbolico.'
          : 'Provider LLM non disponibile. Il fallback simbolico resta operativo.'}
      </span>
    </div>
  );
}
